<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="col-md-12">
					<tool-type-form v-if="showToolTypeForm"
						:edit-mode="editMode"
						:tool-type-prop="type"
						:tool-type-id="toolTypeId"
						@close="closeToolTypeForm"
						@refresh-data="fetchToolTypeData"
					></tool-type-form>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<card :title="$t('toolTypes.toolTypes')" :on-add-object="openToolTypeForm">
					<div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
						<div class="col-12 col-md-4 col-sm-6 mb-2">
							<el-input
								v-model="searchQuery"
								class="search-input"
								clearable
								:prefix-icon="Search"
								:placeholder="$t('common.searchRecords')"
								aria-controls="datatables"
								@keyup="search"
								@clear="handleClearSearch"
							/>
						</div>
					</div>

					<!-- Desktop Table -->
					<el-table v-if="!isMobile" :data="toolTypes">
						<el-table-column
							:prop="'type'"
							:label="$t('toolTypes.toolType')"
							min-width="150"
						/>
						<el-table-column :label="$t('toolTypes.toolCount')" min-width="80">
							<template #default="scope">
								<span>{{ scope.row.toolCount }}</span>
							</template>
						</el-table-column>
						<el-table-column :min-width="150" align="right" label="">
							<template #default="props">
								<div>
									<el-button
										v-if="props.row.toolCount > 0"
										type="primary"
										circle
										:title="$t('toolTypes.moveTools')"
										@click.stop="openMoveToolsModal(props.row)"
									>
										<el-icon>
											<Rank />
										</el-icon>
									</el-button>

									<el-button
										type="warning"
										circle
										@click.stop="handleToolTypeEdit(props.$index, props.row)"
									>
										<el-icon>
											<Edit />
										</el-icon>
									</el-button>

									<el-button
										v-if="props.row.toolCount === 0"
										type="danger"
										circle
										@click.stop="handleDelete(props.$index, props.row)"
									>
										<el-icon>
											<Delete />
										</el-icon>
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>

					<!-- Mobile Table -->
					<el-table v-else :data="toolTypes">
						<el-table-column :label="$t('common.info')">
							<template #default="scope">
								<div>
									<div><strong>{{ scope.row.type }}</strong></div>
									<div><strong>{{ $t('toolTypes.toolCount') }}:</strong> {{ scope.row.toolCount }}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column width="120" align="right" label="">
							<template #default="props">
								<div class="d-flex justify-content-end">
									<el-button
										v-if="props.row.toolCount > 0"
										type="primary"
										circle
										:title="$t('toolTypes.moveTools')"
										@click.stop="openMoveToolsModal(props.row)"
									>
										<el-icon>
											<Rank />
										</el-icon>
									</el-button>

									<el-button
										type="warning"
										circle
										@click.stop="handleToolTypeEdit(props.$index, props.row)"
									>
										<el-icon>
											<Edit />
										</el-icon>
									</el-button>

									<el-button
										v-if="props.row.toolCount === 0"
										type="danger"
										circle
										@click.stop="handleDelete(props.$index, props.row)"
									>
										<el-icon>
											<Delete />
										</el-icon>
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</card>
			</div>
		</div>

		<!-- Move Tools Modal -->
		<move-tools-by-tool-type-modal
			v-model:show="showMoveToolsModal"
			:source-tool-type-id="moveToolsSourceToolTypeId"
			:source-tool-type-name="moveToolsSourceName"
			:tool-types="allToolTypes"
			@tools-moved="fetchToolTypeData"
		/>
	</div>
</template>
<script>
import api from "../../services/api";
import ToolTypeForm from "./ToolTypeForm";
import MoveToolsByToolTypeModal from "../../components/Modals/MoveToolsByToolTypeModal.vue";
import Card from "../../components/Card.vue";
import { ElTable, ElTableColumn, ElInput, ElButton, ElIcon } from 'element-plus';
import { Search, Rank } from '@element-plus/icons-vue';
import { getCustomerConfig } from '../Settings/customerConfigHelper';
import swal from 'sweetalert2';

export default {
	components: {
		ToolTypeForm,
		MoveToolsByToolTypeModal,
		Card,
		ElTable,
		ElTableColumn,
		ElInput,
		ElButton,
		ElIcon
	},
	data() {
		return {
			Search,
			Rank,
			pagination: {
				perPage: 10,
				currentPage: 1,
				total: 0
			},
			isMobile: window.innerWidth <= 1024,
			toolTypes: [],
			allToolTypes: [],
			searchQuery: '',
			type: '',
			toolTypeId: 0,
			showToolTypeForm: false,
			editMode: false,

			showMoveToolsModal: false,
			moveToolsSourceToolTypeId: 0,
			moveToolsSourceName: ''
		};
	},
	created() {
		window.addEventListener('resize', this.updateIsMobile);
		getCustomerConfig('DefaultPageSize')
		.then(config => {
			if (config === '') {
				this.pagination.perPage = 10;
			} else {
				this.pagination.perPage = config;
			}
			this.fetchToolTypeData();
		});
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.updateIsMobile);
	},
	methods: {
		updateIsMobile() {
			this.isMobile = window.innerWidth <= 1024;
		},
		async fetchToolTypeData() {
			try {
				const response = await api.get(`/ToolType?type=${this.searchQuery}`);
				this.toolTypes = response.data;
				this.allToolTypes = response.data.map(tt => ({ id: tt.id, type: tt.type }));
			} catch (error) {
				console.error('API request error:', error); // eslint-disable-line no-console
				this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 });
			}
		},
		handleClearSearch() {
			this.fetchToolTypeData();
		},
		search(event) {
			this.pagination.currentPage = 1;
			const queryLength = this.searchQuery.length;
			if (event.key === 'Backspace' || event.key === 'Enter' || (queryLength > 1 && queryLength % 2 === 0)) {
				this.fetchToolTypeData();
			}
		},
		openMoveToolsModal(row) {
			this.moveToolsSourceToolTypeId = row.id;
			this.moveToolsSourceName = row.type;
			this.showMoveToolsModal = true;
		},
		handleDelete(_index, row) {
			swal.fire({
				title: this.$t('delete.areYouSure'),
				text: this.$t('toolTypes.areYouSureDelete'),
				icon: 'warning',
				showCancelButton: true,
				customClass: {
					confirmButton: 'btn btn-success btn-fill',
					cancelButton: 'btn btn-danger btn-fill'
				},
				confirmButtonText: this.$t('delete.yesDeleteIt'),
				cancelButtonText: this.$t('delete.cancel'),
				buttonsStyling: false
			}).then(result => {
				if (result.value) {
					this.deleteToolType(row);
				}
			});
		},
		deleteToolType(row) {
			api.delete(`/ToolType/${row.id}`)
			.then(() => {
				this.toolTypes = this.toolTypes.filter(tt => tt.id !== row.id);
				this.allToolTypes = this.allToolTypes.filter(tt => tt.id !== row.id);
				swal.fire({
					title: this.$t('delete.deleted'),
					text: `${this.$t('delete.youDeleted')} ${row.type}`,
					icon: 'success',
					customClass: {
						confirmButton: 'btn btn-success btn-fill',
					},
					buttonsStyling: false
				});
			})
			.catch(error => {
				console.error('API request error:', error); // eslint-disable-line no-console
				const message = error.response?.data?.detail || error.response?.data?.title || this.$t('toolTypes.cannotDeleteHasTools');
				swal.fire({
					title: this.$t('common.somethingWentWrong'),
					text: message,
					icon: 'error',
					customClass: {
						confirmButton: 'btn btn-danger btn-fill',
					},
					buttonsStyling: false
				});
			});
		},
		handleToolTypeEdit(_index, row) {
			this.editMode = true;
			this.type = row.type;
			this.toolTypeId = row.id;
			this.openToolTypeForm();
		},
		openToolTypeForm() {
			this.showToolTypeForm = true;
			this.$nextTick(() => {
				window.scrollTo(0, 0);
			});
		},
		closeToolTypeForm() {
			this.showToolTypeForm = false;
			this.type = '';
			this.toolTypeId = 0;
			this.editMode = false;
		},
	},
};
</script>
<style>
</style>
